import React from "react";
import BarraSupDent from "../../../commons/BarraSupDent";
import "../Profile/Profile.css";
import NavbarTechnician from "../../../commons/NavbarTechnician";
import firebaseManager from "../../../model/Firebase/FirebaseManager";
import profile from "../../../assets/images/profile.png";
import { Link } from "react-router-dom";

class Profile extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor(props) {
    super();
    this.state = {
      userData: [],
      image: null,
    };
    this.getDentuser();
  }

  getDentuser() {
    firebaseManager.getInfoForCurrentTechnician(this.getDentIdsCallback);
  }

  getDentIdsCallback = (dentIdData) => {
    this.setState({
      userData: this.state.userData.concat([dentIdData]),
    });

    let userData = document.getElementById("userData");
    if (userData) {
      userData.innerHTML += `
        <div class="text-center mx-auto pt-2">
        <img src=${
          dentIdData.photoProfile || profile
        } alt="profile"  class="rounded-circle profileImg mb-2"/>
        <p class="mt-3">${dentIdData.name} </p>
      
        
        <table class="table table-borderless profile m-auto">
        <tbody>
          <tr>
            
            <td>EMAIL:</td>
            <td>${dentIdData.email || ""}</td>
           
          </tr>
          <tr>
          
            <td>PHONE NUMBER:</td>
            <td>${dentIdData.phoneNumber || ""}</td>
          </tr>
          <tr>                          
          <td>ADDRESS:</td>
          <td>${dentIdData.address || ""}</td>
          </tr>
          </tbody>
        </table>
        </div>
  `;
    }
    if (dentIdData.phoneNumber === "") {
      document.getElementById("alertTec").classList.remove("d-none");
      document.getElementById("navbarTec").classList.add("d-none");
      document.getElementById("btnBack").classList.remove("d-none");
    }
  };

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <div id="alertTec" className="alert alert-danger d-none" role="alert">
          <p className="text-center">
            Please provide your phone number, just in case needs to contact you.
          </p>
        </div>
        <div className="text-center mb-5">
          <div
            className="text-center mt-5 d-flex justify-content-center align-items-center"
            id="userData"
          ></div>
          <div className="mb-5 pb-5">
            <Link to="/accountSettings">
              <p className="pSize colorLink text-center mb-5 mt-4">
                Account settings
              </p>
            </Link>
          </div>
        </div>
        <NavbarTechnician />
      </React.Fragment>
    );
  }
}

export default Profile;
